// check for network error
export function isNetworkError(err) {
  if (!!err.isAxiosError && !err.response) {
    return true;
  }
  return false;
}
